import * as actions from "./actions";
import initialState from "./initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    case actions.SET_SELECTED:
      return {
        ...state,
        selected: action.payload
      }
    case actions.SET_PLACES:
      return {
        ...state,
        data: action.payload
      }
    default:
      return state
  };
};